/* Filter and sortingKeys */
export const sortBy = 'sortBy';
export const sortOrder = 'sortOrder';
export const filterSubject = 'filterSubject';
export const filterAnsweredRange = 'filterAnsweredRange';
export const filterRating = 'filterRating';
export const ordScaleLength = 'ordScaleLength';
export const filterNoAnswers = 'filterNoAnswers';
export const filterWithComments = 'filterWithComments';

/* sortingValues for DropDowns */
export enum SortingValues {
  /*ASC*/
  Created_asc = 'created',
  ResponseRate_asc = 'response_rate',
  RecentlyAnswered_asc = 'last_answered',
  MostAnswered_asc = 'answered',
  SurveyNames_asc = 'survey_names',
  DefaultString_asc = 'default',
  Rating_asc = 'rating',
  LastAnswered_asc = 'last_answered',
  Answered_asc = 'answered',
  QuestionText_asc = 'question_text',
  TopicNames_asc = 'topic_names',
  LastMail_asc = 'last_mail',
  Fullname_asc = 'fullname',
  Firstname_asc = 'firstname',
  Lastname_asc = 'lastname',
  Progress_asc = 'progress',
  Last_modified = '-last_modified',
  Name_asc = 'name',
  /*DESC*/
  ResponseRate_desc = '-response_rate',
  RecentlyAnswered_desc = '-last_answered',
  MostAnswered_desc = '-answered',
  SurveyNames_desc = '-survey_names',
  Rating_desc = '-rating',
  LastAnswered_desc = '-last_answered',
  Answered_desc = '-answered',
  QuestionText_desc = '-question_text',
  TopicNames_desc = '-topic_names',
  LastMail_desc = '-last_mail',
  Created_desc = '-created',
  Fullname_desc = '-fullname',
  Firstname_desc = '-firstname',
  Lastname_desc = '-lastname',
  Progress_desc = '-progress',
  Name_desc = '-name',
  ManagerFinishedAt_asc = 'managerFinishedAt',
  ManagerFinishedAt_desc = '-managerFinishedAt',
  UserFinishedAt_asc = 'userFinishedAt',
  UserFinishedAt_desc = '-userFinishedAt',
}

/* periodValues for DropDowns */
export enum PeriodValues {
  AllTime = 'allTime',
  LastYear = 'lastYear',
  LastMonth = 'lastMonth',
  LastQuarter = 'lastQuarter',
}
